import { FC, ReactNode } from "react";

import { Stack } from "@mui/material";

import { useTranslate } from "../../../../../hooks/useTranslate";
import { MODAL_Z_INDEX } from "../constants";

import { DashboardIcon } from "@/dashboard-design-system/Icon";
import { DashboardSwitch } from "@/dashboard-design-system/Switch";
import { DashboardTooltip } from "@/dashboard-design-system/Tooltip";
import { DashboardTypography } from "@/dashboard-design-system/Typography";
import { Info } from "@/icons/outlined";

export type CampaignPermissionsSectionProps = {
  slots: {
    title: string;
    campaignSelector: ReactNode;
  };
  permissions: {
    editForm: {
      checked: boolean;
      onChange: (checked: boolean) => void;
    };
    managePayments: {
      checked: boolean;
      onChange: (checked: boolean) => void;
    };
    receipt: {
      checked: boolean;
      onChange: (checked: boolean) => void;
    };
  };
  disabled?: boolean;
};

export const CampaignPermissionsSection: FC<CampaignPermissionsSectionProps> = ({ slots, permissions, disabled }) => {
  const { t } = useTranslate();

  return (
    <Stack direction="column" gap={1}>
      <DashboardTypography variant="subtitle2" vibe="text-neutral-quiet">
        {slots.title.toUpperCase()}
      </DashboardTypography>

      <Stack direction="column" gap={1.5}>
        {slots.campaignSelector}

        <Stack direction="column" gap={1.5}>
          <Stack direction="row" gap={0.5} alignItems="center">
            <DashboardSwitch
              data-test="switch-form-permissions-edit-form"
              label={t("dashboard", "userPermissionModal.formPermission.editForm")}
              checked={permissions.editForm.checked}
              onChange={(event) => permissions.editForm.onChange(event.target.checked)}
              disabled={disabled}
            />
            <DashboardTooltip
              title={t("dashboard", "userPermissionModal.formPermission.editForm.tooltip")}
              placement="top"
              PopperProps={{
                sx: {
                  zIndex: MODAL_Z_INDEX + 1,
                },
              }}
            >
              <DashboardIcon size="small" sx={{ cursor: "pointer" }}>
                <Info />
              </DashboardIcon>
            </DashboardTooltip>
          </Stack>
          <Stack direction="row" gap={0.5} alignItems="center">
            <DashboardSwitch
              data-test="switch-form-permissions-manage-payments"
              label={t("dashboard", "userPermissionModal.formPermission.managePayments")}
              checked={permissions.managePayments.checked}
              onChange={(event) => permissions.managePayments.onChange(event.target.checked)}
              disabled={disabled}
            />
            <DashboardTooltip
              title={t("dashboard", "userPermissionModal.formPermission.managePayments.tooltip")}
              placement="top"
              PopperProps={{
                sx: {
                  zIndex: MODAL_Z_INDEX + 1,
                },
              }}
            >
              <DashboardIcon size="small" sx={{ cursor: "pointer" }}>
                <Info />
              </DashboardIcon>
            </DashboardTooltip>
          </Stack>
          <DashboardSwitch
            data-test="switch-form-permissions-receipt"
            label={t("dashboard", "userPermissionModal.formPermission.receipt")}
            checked={permissions.receipt.checked}
            onChange={(event) => permissions.receipt.onChange(event.target.checked)}
            disabled={disabled}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
